import * as React from 'react';
import { clsx } from 'clsx';

import { TTaTab } from '../../../../types/infrastructure';
import * as styles from './styles.css';

export interface ITaRateIconProps {
  tab: TTaTab;
}

/** Иконка оценки Дептранса: дом для «Внутри ЖК», пин для «Рядом с ЖК» — как в map-search. */
export function TaRateIcon({ tab }: ITaRateIconProps): React.JSX.Element {
  return <div className={clsx(styles['icon'], styles[`icon--${tab}`])} />;
}
